import { CatalogAPIData, RawCatalogAPIData } from 'types/catalog_types';

const flattenCatalogTemplates = (catalog: RawCatalogAPIData): CatalogAPIData => ({
  ...catalog,
  templates: catalog.templates?.map((t) => t.id) || [],
});

export default {
  flattenCatalogTemplates,
};
